export default require('./TabTranscripts').default
